import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const loader = () => import( /* webpackChunkName: "SingleReportViewerSidebarContainer" */'./fullPage/sidebar/SingleReportViewerSidebarContainer');
export default Loadable({
  loader,
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true
  })
});